<template>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <div class="lead">
          {{ $t('vendorManagementRequestChart.tdarkMracitlri') }}
        </div>
        <div>
          <download-excel
            :data="reportData"
            name="report.xls"
            class="btn btn-success mr-2"
            header="Tədarükçü müraciətləri"
            :fields="{
              'Fəaliyyət sahəsi	':'sectorName',
              'Təsdiqlənmiş tədarükçü':'vendorCount',
              'Təsdiqlənmiş müraciət':'approvedFormCount',
              'Gözləyən müraciət':'waitingFormCount',
              'Geri qaytarılmış müraciət':'returnedFormCount',
              'Yenidən doldurulacaq müraciət':'expiredFormCount',
              'Ləğv edilmiş müraciət':'rejectedFormCount'
            }"
          >
            <feather
              type="table"
              size="14"
            />
            {{ $t('newAUCRequest.ykl') }}
          </download-excel>

          <router-link
            class="btn btn-outline-dark"
            :to="{name: 'vendorManagementRequestList'}"
          >
            {{ $t('vendorManagementVendorRequestReport.btnMracitlr') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>{{ $t('vendorManagementPurchasesReports.faliyytSahsi') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.tsdiqlnmiTdark') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.tsdiqlnmiMracit') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.gzlynMracit') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.geriQaytarlmMracit') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.yenidnDoldurulacaqMracit') }}</th>
            <th>{{ $t('vendorManagementVendorRequestReport.lvEdilmiMracit') }}</th>
          </tr>
        </thead>
        <tbody class="text-center">
          <template v-for="s in reportData">
            <tr>
              <td class="text-left">
                <span v-if="s.profileType==='LOGISTIC'">{{ $t('vendorManagementVendorRequestReport.logistikMracitlri') }}</span>
                <span v-else-if="s.profileType==='TRUCK'">{{ $t('vendorManagementVendorRequestReport.trSahibiMracitlri') }}</span>
                <span v-else>{{ s.sectorName }}</span>
              </td>

              <td>
                <router-link
                  v-if="s.vendorCount>0"
                  class="badge bg-success"
                  :to="{name: 'vendorManagementVendorList', query:{sectorId: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.vendorCount }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>
                <router-link
                  v-if="s.approvedFormCount>0"
                  class="badge bg-success"
                  :to="{name: 'vendorManagementRequestList', query:{ status: 'APPROVED', sector: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.approvedFormCount || '-' }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>
                <router-link
                  v-if="s.waitingFormCount>0"
                  class="badge bg-danger"
                  :to="{name: 'vendorManagementRequestList', query:{ status: 'WAITING', sector: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.waitingFormCount || '-' }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>
                <router-link
                  v-if="s.returnedFormCount>0"
                  class="badge bg-warning"
                  :to="{name: 'vendorManagementRequestList', query:{ status: 'RETURNED', sector: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.returnedFormCount || '-' }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>
                <router-link
                  v-if="s.expiredFormCount>0"
                  class="badge bg-primary"
                  :to="{name: 'vendorManagementRequestList', query:{ status: 'EXPIRED', sector: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.expiredFormCount || '-' }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>
                <router-link
                  v-if="s.rejectedFormCount>0"
                  class="badge bg-dark"
                  :to="{name: 'vendorManagementRequestList', query:{ status: 'REJECTED', sector: s.sectorId, profile: s.profileType}}"
                >
                  {{ s.rejectedFormCount || '-' }}
                </router-link>
                <span v-else>-</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {getFormSectorStatistics} from "@/repositories/VendorManagementRepository";
import {mapState} from "vuex";

export default {
  name: 'VendorManagementVendorRequestReport',
  data() {
    return {
      reportData: {}
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  mounted() {
    this.getFormFormSectorStatistics();
  },
  methods: {
    getFormFormSectorStatistics() {

      getFormSectorStatistics(this.token).then(({code, statistics, requests30Days}) => {
        if (code === 200) {
          this.reportData = statistics;
        }
      })

    },

  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>